import { useSelector } from "react-redux";
import PixelatedImage from "../PixelatedImage";
import classes from './ImageLetterContainer.module.scss';
import { PIXELATED_LEVEL, SIZE_INPUT, VARIANT_INPUT } from "../../utils/constants";
import { useDeferredValue, useState } from "react";
import { PhraseInput } from "../PhraseInput";
import clsx from 'clsx';
import { useMediaQuery } from "@educaplay/core";
import useClues from "../CluesProvider/useClues";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { SkipButton } from '@educaplay/core/components/SkipButton';

const DELAY_APPEAR_BUTTON = 5000;

function ImageLetterContainer(props) {
    const { onChange, inputValue, stateVariant, inputRef, imageRef, inputAnimationRef, changePointsLose, pixelateImage, onSkip } = props;
    const { pixelatedLevel, pointsLose, numClues, numRequestedClues } = useClues();
    const questions = useSelector(state => state.game.questions);
    const currentIndex = useSelector(state => state.game.currentIndex);
    const currentQuestion = questions[currentIndex];
    const numQuestions = questions.length;
    const hasImage = !!currentQuestion.image;
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const isSizeMobile = useMediaQuery("(max-width: 769px)");
    const answerCharactersCount = inputValue.reduce((total, array) => total + array.length, 0);
    const minSizeCard = isSizeMobile && answerCharactersCount >= 16;
    const size = isSizeMobile && answerCharactersCount > 16 ? SIZE_INPUT.SMALL : SIZE_INPUT.DEFAULT;
    const [anyInputFocus, setAnyInputFocus] = useState(false);
    const hasInputFocus = useDeferredValue(anyInputFocus);
    const isAnimating = useSelector(state => state.game.isAnimating);
    const isCompleteEntryAnimation = useSelector(state => state.game.isCompleteEntryAnimation);
    const [showSkipButton, setShowSkipButton] = useState(false);

    useEffect(() => {
        changePointsLose(pointsLose);
    }, [pointsLose, changePointsLose]);


    useEffect(() => {
        if (numClues !== numRequestedClues) return;
        if (currentQuestion.tries.length >= 2) setShowSkipButton(true);

    }, [numClues, numRequestedClues, currentQuestion.tries.length]);

    useEffect(() => {
        if (numClues !== numRequestedClues) return;

        const buttonTimeOut = setTimeout(() => {
            setShowSkipButton(true);
        }, DELAY_APPEAR_BUTTON);

        return () => {
            clearTimeout(buttonTimeOut)
        }

    }, [numClues, numRequestedClues])


    const lettersContainerVariants = {
        [classes.letterscontainer]: true,
        [classes.noimage]: !hasImage,
        [classes.positioninputfocus]: isTouchDevice && hasInputFocus
    }
    const variantInput = hasImage ? VARIANT_INPUT.TRANSPARENT : VARIANT_INPUT.DEFAULT;

    const onFocusHandler = () => {
        setAnyInputFocus(true);
    }

    const onBlurHandler = () => {
        setAnyInputFocus(false);
    }

    const onChangeHandler = (newWords) => {
        onChange(newWords, pointsLose);
    }

    return (
        <>
            {hasImage && <motion.div ref={imageRef} className={classes.imagecontainer} initial={{ opacity: 0, scale: .2 }} >
                <div className={classes.animationcontainer}>
                    <PixelatedImage
                        className={classes.canvaspixelated}
                        src={currentQuestion.image}
                        pixelSize={pixelateImage ? PIXELATED_LEVEL[pixelatedLevel] : 0}
                    />

                </div>
            </motion.div>}
            <motion.div ref={inputAnimationRef} className={clsx(lettersContainerVariants)} onFocus={onFocusHandler} onBlur={onBlurHandler} initial={{ opacity: 0, scale: .2 }}>
                <PhraseInput
                    ref={inputRef}
                    words={inputValue}
                    onChange={onChangeHandler}
                    minSizeCard={minSizeCard}
                    variant={variantInput}
                    variantValidation={stateVariant}
                    size={size}
                    disabled={isAnimating && isCompleteEntryAnimation}
                />
            </motion.div>
            <SkipButton show={showSkipButton} onSkip={onSkip} isLastQuestion={currentIndex === numQuestions - 1} />
        </>
    )
}

export default ImageLetterContainer; 